// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../../../fragments/commonFragments.generated';
export type ScopeChangesTable_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Region_Fragment = { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Market_Fragment = { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Community_Fragment = { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Lot_Fragment = { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Structure_Fragment = { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_Project_Unit_Fragment = { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } };

export type ScopeChangesTable_ProjectFragment =
  | ScopeChangesTable_Project_StandaloneProject_Fragment
  | ScopeChangesTable_Project_Region_Fragment
  | ScopeChangesTable_Project_Market_Fragment
  | ScopeChangesTable_Project_Community_Fragment
  | ScopeChangesTable_Project_Subdivision_Fragment
  | ScopeChangesTable_Project_Lot_Fragment
  | ScopeChangesTable_Project_Structure_Fragment
  | ScopeChangesTable_Project_Unit_Fragment
;

export type ScopeChangesTable_ChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', quantity?: number | null | undefined, totalCostInCents: number, totalPriceInCents: number, id: string, name: string, proposedTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, originalTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, useQuantity: boolean, abbreviation: string }, originalBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean } | null | undefined, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string } } } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, projectMarkupBasisPoints: number, project:
      | { __typename?: 'StandaloneProject', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Region', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Market', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Community', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Subdivision', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Lot', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Structure', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
      | { __typename?: 'Unit', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } }
     }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined };

export type ScopeChangesTable_LineItemTradeFragment = { __typename?: 'ChangeEventLineItem', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, ofIti: boolean, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, displayName: string } } } | null | undefined };

export const ScopeChangesTable_ProjectFragmentDoc = gql`
    fragment ScopeChangesTable_Project on Project {
  id
  lotType {
    code
  }
}
    `;
export const ScopeChangesTable_LineItemTradeFragmentDoc = gql`
    fragment ScopeChangesTable_LineItemTrade on ChangeEventLineItem {
  id
  tradePartner {
    id
    name
  }
  proposedBidContractLineItem {
    id
    ofIti
    revision {
      id
      version
      bidContract {
        id
        displayName
      }
    }
  }
}
    `;
export const ScopeChangesTable_ChangeEventLineItemFragmentDoc = gql`
    fragment ScopeChangesTable_ChangeEventLineItem on ChangeEventLineItem {
  ...Named
  quantity
  totalCostInCents
  totalPriceInCents
  proposedTask {
    ...Named
  }
  originalTask {
    ...Named
  }
  typeDetail {
    code
    name
  }
  item {
    ...DisplayNamed
    costCode {
      ...DisplayNamed
    }
  }
  unitOfMeasure {
    id
    useQuantity
    abbreviation
  }
  originalBidContractLineItem {
    id
    forCoveringTakeoffs
  }
  proposedBidContractLineItem {
    id
    forCoveringTakeoffs
  }
  projectItem {
    id
    projectMarkupBasisPoints
    project {
      id
      canEditPrice {
        allowed
      }
    }
  }
  ...ScopeChangesTable_LineItemTrade
}
    ${NamedFragmentDoc}
${DisplayNamedFragmentDoc}
${ScopeChangesTable_LineItemTradeFragmentDoc}`;